import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "pt",
  setLang: () => {},
  t: translations.pt,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = window.localStorage.getItem("synergia_lang");
      return saved === "en" ? "en" : "pt";
    } catch {
      return "pt";
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("synergia_lang", lang);
    } catch {}
    document.documentElement.lang = lang === "en" ? "en" : "pt-BR";
  }, [lang]);

  const setLang = (newLang) => setLangState(newLang === "en" ? "en" : "pt");
  const t = translations[lang] || translations.pt;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
